export const SET_RESUMO_UPLOAD = "SET_RESUMO_UPLOAD";
export const LOADING_RESUMO_UPLOAD = "LOADING_RESUMO_UPLOAD";
export const ERROR_RESUMO_UPLOAD = "ERROR_RESUMO_UPLOAD";
export const HANDLE_CHANGE_CHECK_BOX1 = "HANDLE_CHANGE_CHECK_BOX1";
export const HANDLE_CHANGE_CHECK_BOX2 = "HANDLE_CHANGE_CHECK_BOX2";

